import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'
// import { responsiveImageFragment } from '../fragments/images'

export const questionarioPage = gql`
  ${seoFragment}
  query QuestionarioPage($locale: SiteLocale) {
    questionario(locale: $locale) {
      seo {
        ...SeoFragment
      }
      _allSlugLocales {
        value
        locale
      }
      titolo
      slug
      intro {
        titolo
        testoSinistra
      }
    }
  }
`
